module.exports = __webpack_public_path__ + "img/bms_conectado.b3b5ea48.jpg";